import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Button, Stack } from '@mui/material';
import { Visibility, PictureAsPdf,Edit, Delete, Add, ArrowUpward, ArrowDownward  } from '@mui/icons-material';
import fascicoloApi from '../../api/fascicoloApi';
import DocumentoFascicoloTable from '../../components/DocumentoFascicoloTable';
import RichiesteDocumentoNonEvaseTable from '../../components/RichiesteDocumentoNonEvaseTable';
import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import FascicoloChat from '../../components/FascicoloChat';
import { formatDate } from '../../utils/dateFormatter';

export default function FascicoloDetailPageDesktop() {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const pageSize = 10;
  const [contribuente, setContribuente] = useState({});
  const [documenti, setDocumenti] = useState([]);
  const [richiesteNonEvase, setRichiesteNonEvase] = useState([]);
  const [fascicoloId, setFascicoloId] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [sortField, setSortField] = useState('dataUpload');
  const [sortDirection, setSortDirection] = useState('DESC'); // ASC o DESC
  console.log("user",user);
  useEffect(() => {
    const fetchFascicolo = async () => {
      try {
        const res = id
          ? await fascicoloApi.getFascicoloByContribuenteId(id)
          : await fascicoloApi.getMyFascicolo();
        setFascicoloId(res.data.id);
        setContribuente(res.data.contribuente);
        //setDocumenti(res.data.documenti);
        //fetchDocumentiFascicolo(res.data.id);
        fetchDocumentiFascicolo(res.data.id,0);
        console.log("documenti",documenti);
        fetchRichiesteNonEvase(res.data.id);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchRichiesteNonEvase = async (fid) => {
      try {
        const res = await fascicoloApi.getRichiesteNonEvase(fid);
        setRichiesteNonEvase(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchFascicolo();
  }, [id,sortField,setSortDirection]);

const fetchDocumentiFascicolo = async (fid,page) => {
  try {
    const params = { page, size: pageSize, sort: `${sortField},${sortDirection}` };
    const res = await fascicoloApi.getDocumentiFascicoloPaginated(fid,params);
    setDocumenti(res.data.content || [])
    setTotalPages(res.data.totalPages || 0);
    setPage(res.data.number || 0)
  } catch (err) {
    console.error(err);
  }
};
  const handleNuovoDocumento = () => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`);
  };

  const handleParseDocumento = (doc) => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`, {
      state: { documentoFascicoloId: doc.id }
    });
  };

  const handleDownload = async (documentoId, fileName) => {
    try {
      const response = await fascicoloApi.downloadDocumento(documentoId);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (documentoId) => {
    try {
      await fascicoloApi.deleteDocumento(documentoId);
      setDocumenti(documenti.filter(d => d.id !== documentoId));
    } catch (err) {
      console.error(err);
    }
  };

  const handleCambiaStatoRichiesta = async (richiestaId, stato) => {
    try {
      await fascicoloApi.changeStatoRichiesta(richiestaId, stato);
      console.log("handleCambiaStatoRichiesta",fascicoloId);
      try {
        const res = await fascicoloApi.getRichiesteNonEvase(fascicoloId);
        setRichiesteNonEvase(res.data);
      } catch (err) {
        console.error(err);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreaDocumentoDaRichiesta = (richiestaId, tipo) => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`, { state: { richiestaId, tipo } });
  };

  const handleSort = (field) => {
    console.log("sortField",field);
    if (sortField === field) {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
      console.log("sortDirection",sortDirection);
    } else {
      setSortField(field);
      setSortDirection('ASC');
       console.log("sortDirection",sortDirection);
    }
    fetchDocumentiFascicolo(fascicoloId,page);
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  return (
    <Container>
      <BackButtonDesktop />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Fascicolo di {contribuente.nome} {contribuente.cognome}
      </Typography>

      <Box mt={6}>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Typography variant="h6">Richieste Documento</Typography>
          <ProtectedAction user={user} roles={['ADMIN', 'STUDIO']} contractState={user.statoContratto}>
            <Button
              variant="contained"
              sx={{ my: 1 }}
              onClick={() => navigate(`/fascicolo/${fascicoloId}/richieste/create`)}
              disabled={!fascicoloId}
            >
              Nuova richiesta
            </Button>
          </ProtectedAction>
        </Stack>

        <RichiesteDocumentoNonEvaseTable
          richieste={richiesteNonEvase}
          onCambiaStato={handleCambiaStatoRichiesta}
          onCreaDocumento={handleCreaDocumentoDaRichiesta}
          onDownload={handleDownload}
        />
      </Box>

      <Box mt={4}>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Typography variant="h6">Documenti Fascicolo</Typography>
          <ProtectedAction user={user} contractState={user.statoContratto}>
            <Button variant="contained" onClick={handleNuovoDocumento} disabled={!fascicoloId}>
              Carica Documento
            </Button>
          </ProtectedAction>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              variant={i === page ? "contained" : "outlined"}
              onClick={() => fetchDocumentiFascicolo(fascicoloId,i)}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>
        <DocumentoFascicoloTable
          documenti={documenti}
          contribuenteId={contribuente.id}
          onDownload={handleDownload}
          onDelete={handleDelete}
          onParse={handleParseDocumento} // ← nuovo
          onHandleSort={handleSort}
        />
        <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              variant={i === page ? "contained" : "outlined"}
              onClick={() => fetchDocumentiFascicolo(fascicoloId,i)}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>
      </Box>
      {fascicoloId && contribuente.studio && user.chatisactive==true && (
        <FascicoloChat fascicoloId={fascicoloId} />
      )}
    </Container>
  );
}